module.exports = __webpack_public_path__ + "img/not-authorized.0ac6340e.png";